import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { createStructuredSelector } from 'reselect';
import { injectIntl } from 'react-intl';
import { withRouter } from 'react-router-dom';
import { hot } from 'react-hot-loader';
import { compose } from 'ramda';

import { CookiesOverlay } from './cookiesOverlay.component';
import { selectIsOverlayStandalone, selectIsCookiesVisible, OverlayActions } from '../../../modules/overlay';
import { LegalActions, selectCookiesPolicyContent } from '../../../modules/legal';

const mapStateToProps = createStructuredSelector({
  content: selectCookiesPolicyContent,
  isVisible: selectIsCookiesVisible,
  isStandalone: selectIsOverlayStandalone,
});

export const mapDispatchToProps = dispatch =>
  bindActionCreators(
    {
      showOverlay: OverlayActions.showCookies,
      hideOverlay: OverlayActions.hideOverlay,
      fetchCookies: LegalActions.fetchCookiesPolicy,
    },
    dispatch
  );

export default compose(
  hot(module),
  connect(
    mapStateToProps,
    mapDispatchToProps
  ),
  injectIntl,
  withRouter
)(CookiesOverlay);
